"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var byFieldKey = function findControlByFieldKey(controls, fieldKey) {
  for (var i = 0; i < controls.length; i += 1) {
    var control = controls[i];

    if (fieldKey === control.fieldData.fieldKey) {
      return controls[i];
    }
  }

  return null;
};

var _default = {
  byFieldKey: byFieldKey
};
exports["default"] = _default;